import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  SideOptionBtn,
  // BackOptionBtn,
  SideOptionBox,
} from "../FooterStyled";
import { ReactComponent as CleanSVG } from "../../../../svg/clean.svg";
import { ReactComponent as RandomSVG } from "../../../../svg/random.svg";
// import { ReactComponent as BackSVG } from "../../../../svg/back.svg";
import useBetOperations from "../../bet/useBetOperations";
import useSound from "use-sound";
import clearSound from "../../../../audio/clear.mp3";

export default function SideOptions({
  showOptions,
  handleNotification,
  toFix,
  clean,
  random,
  toggle,
  minBet,
  maxBet,
  currency,
  sound,
  volume,
  n,
}) {
  const [clearSFX] = useSound(clearSound, { volume });

  const st = useSelector((s) => s);

  const [, , , multiply, divide] = useBetOperations(
    st.bet,
    true,
    sound,
    handleNotification,
    toFix,
    minBet,
    maxBet,
    currency,
    volume
  );

  const { gameMode } = st;
  // const { gameMode } = userSettings;
  const [clearAnim, setclearAnim] = useState(false);
  const [randAnim, setrandAnim] = useState(false);
  const [halfAnim, sethalfAnim] = useState(false);
  const [multAnim, setmultAnim] = useState(false);

  const [lastClicked, setlastClicked] = useState(false);

  useEffect(() => {
    if (lastClicked) {
      setTimeout(() => {
        setlastClicked(false);
      }, 1000);
    }
  }, [lastClicked]);

  return (
    <SideOptionBox className="SideOptionBox" showOptions={showOptions}>
      <SideOptionBtn
        className="SideOptionBtn"
        modeSonic={gameMode === "sonic"}
        showOptions={showOptions}
        delay={showOptions ? "120ms" : "0ms"}
        onClick={() => {
          clean();
          if (sound && n > 0) clearSFX();

          setclearAnim(true);
          setTimeout(() => {
            setclearAnim(false);
          }, 200);
        }}
        anim={clearAnim}
      >
        <div className="white" />
        <CleanSVG className="CleanSVG" />
      </SideOptionBtn>
      <SideOptionBtn
        onClick={() => {
          clean();
          setrandAnim(true);
          setTimeout(() => {
            setrandAnim(false);
          }, 200);
          random(40);
        }}
        showOptions={showOptions}
        delay={showOptions ? "80ms" : "40ms"}
        anim={randAnim}
      >
        <div className="white" />
        <RandomSVG className="randomSonicSVG" />
      </SideOptionBtn>
      <SideOptionBtn
        id="divide"
        delay={showOptions ? "40ms" : "80ms"}
        showOptions={showOptions}
        onClick={() => {
          if (!lastClicked) {
            setlastClicked("divide");
            sethalfAnim(true);
            setTimeout(() => {
              sethalfAnim(false);
              divide();
              setTimeout(() => {
                toggle();
              }, 0);
            }, 300);
          }
        }}
        anim={halfAnim}
      >
        <div className="white" />
        1/2
      </SideOptionBtn>
      <SideOptionBtn
        id="multiply"
        showOptions={showOptions}
        delay={showOptions ? "0ms" : "120ms"}
        onClick={() => {
          if (!lastClicked) {
            setlastClicked("multiply");
            setmultAnim(true);
            setTimeout(() => {
              setmultAnim(false);
              multiply();
              setTimeout(() => {
                toggle();
              }, 0);
            }, 300);
          }
        }}
        anim={multAnim}
      >
        <div className="white" />
        2x
      </SideOptionBtn>
      {/* <BackOptionBtn onClick={toggle}>
        <BackSVG />
      </BackOptionBtn> */}
    </SideOptionBox>
  );
}

// const mapStateToProps = state => {
//   return state;
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     handleBet: i => dispatch(handleBet(i))
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(SideOptions);
